import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PhaseManagement from './pages/phase-management';
import Login from './pages/login';
import ProjectCreation from './pages/project-creation';
import ProjectDetails from './pages/project-details';
import ProjectOverview from './pages/project-overview';
import BossHomePage from './pages/boss-home-page';
import WorkerHomePage from './pages/worker-home-page';
import WorkersManagePhase from './pages/workers-manage-phase';
import CreateAccount from './pages/create-account';
import ForgotPassword from './pages/forgot-password';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Login />} />
        <Route path="/phase-management" element={<PhaseManagement />} />
        <Route path="/workers-manage-phase" element={<WorkersManagePhase />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/project-creation" element={<ProjectCreation />} />
        <Route path="/project-details" element={<ProjectDetails />} />
        <Route path="/project-overview" element={<ProjectOverview />} />
        <Route path="/boss-home-page" element={<BossHomePage />} />
        <Route path="/homepage" element={<BossHomePage />} />
        <Route path="/worker-home-page" element={<WorkerHomePage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;